import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Injector } from '@angular/core';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { UiComponent } from '@df/ui/ui.component';
import { StickyFreeComponent } from '../sticky-free/sticky-free.component';
import { ScrollNavScope } from './scroll-nav-scope';
import { ScrollNavTargetDirective } from './scroll-nav-target.directive';

@Component({
    selector: 'scroll-nav',
    templateUrl: './scroll-nav.html',
    styleUrls: ['./scroll-nav.scss'],
    standalone: true,
    imports: [StickyFreeComponent, DragScrollDirective, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollNavComponent extends UiComponent {
    protected items: ScrollNavTargetDirective[] = [];

    constructor(
        injector: Injector,
        private elementRef: ElementRef<HTMLElement>,
        private scrollNavScope: ScrollNavScope
    ) {
        super();
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            this.scrollNavScope.targets$.subscribe(targets => {
                this.items = targets;
                this.detectChanges();
            })
        );
        this.subscriptions.add(
            this.scrollNavScope.focus$.subscribe(target => {
                this.detectChanges();
                this.scrollFocusedIntoView();
            })
        );
        super.ngOnInit();
    }

    protected isFocus(item: ScrollNavTargetDirective): boolean {
        return this.scrollNavScope.focus$.value === item;
    }

    private scrollFocusedIntoView() {
        const activeButton = this.elementRef.nativeElement.querySelector('._focus');
        if (activeButton) {
            const container = activeButton.parentElement!;
            const containerRect = container.getBoundingClientRect();
            const activeRect = activeButton.getBoundingClientRect();

            if (activeRect.left < containerRect.left) {
                container.scrollTo({ left: container.scrollLeft + activeRect.left - containerRect.left - 10, behavior: 'smooth' });
            } else {
                if (activeRect.right > containerRect.right) {
                    container.scrollTo({ left: container.scrollLeft + activeRect.right - containerRect.right + 10, behavior: 'smooth' });
                }
            }
        }
    }

    protected scrollTo(item: ScrollNavTargetDirective) {
        console.log('scrollTo', item);
        item.scrollTo();
    }
}
